import {defineMessages} from 'react-intl';

export default defineMessages({
	trackOrder: {
		id: 'orders.trackOrder',
		defaultMessage: 'Track order',
	},
	requestReturn: {
		id: 'orders.requestReturn',
		defaultMessage: 'Request return / exchange',
	},
	youPurchasedItem: {
		id: 'orders.youPurchasedItem',
		defaultMessage: 'You purchased 1 item:',
	},
	youPurchasedItems: {
		id: 'orders.youPurchasedItems',
		defaultMessage: 'You purchased {items} items:',
	},
	recentOrdersExchanged: {
		id: 'orders.recentOrdersExchanged',
		defaultMessage: 'Items can be returned',
	},
	returnRequested: {
		id: 'orders.returnRequested',
		defaultMessage: 'Return Requested',
	},
	shippingAddressLabel: {
		id: 'orders.details.shippingAddressLabel',
		defaultMessage: 'Shipping Address',
	},
	billingAddressLabel: {
		id: 'orders.details.billingAddressLabel',
		defaultMessage: 'Billing Address',
	},
});
